import React, {  useEffect } from "react";
import { useLocation, } from "react-router-dom"; // Assurez-vous d'importer le hook useLocation


const WaterMachinePreview: React.FC = () => {



  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const data = queryParams.get("data");

    if (data) {
  
    }
  }, [location]);

  //   const { id } = useParams();
  //   const fetchProductById = async (productId: any) => {
  //     try {
  //       const { data, error } =
  //         await waterMachineServiceInstance.getWaterMachineById(productId);

  //       if (data) {
  //         setSelectedProduct(data);


  //       } else {
  //         console.error("Error fetching product by ID:", error);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching product by ID:", error);
  //     }
  //   };

  //   useEffect(() => {
  //     if (id) {
  //       fetchProductById(id);
  //     }
  //   }, [id]);

  return (
    <>
    </>
    // <div>
    //   {selectedProduct ? (
    //     <div>
    //       {/* <Header isHalf textBackground='WATTER MAKERS' title='Sparkling Water Makers' backgroundImg={Images.WaterMakerProductBg} /> */}
    //       <Navbar />
    //       <section>
    //         <div className="bg-[#FFFFFF] text-start md:px-20 px-10 py-10 md:py-0">
    //           <Breadcrumb items={breadcrumbItems} />
    //         </div>
    //         <div className="flex flex-col md:flex-row md:gap-0 gap-5">
    //           <div className="basis-[50%] md:px-20 px-10 text-start">
    //             <div className="flex gap-4 items-center">
    //               <div className="flex flex-col gap-4">
    //                 <div
    //                   onClick={() => setSelectedView("images")}
    //                   className="p-4 rounded-full bg-[#75A7AD]"
    //                   style={{
    //                     boxShadow: "0px 3px 6px #00000029",
    //                     backgroundColor:
    //                       selectedView === "images" ? "#75A7AD" : "#FFFFFF",
    //                   }}
    //                 >
    //                   <BsImages
    //                     fontSize={25}
    //                     color={selectedView === "images" ? "white" : "black"}
    //                   />
    //                 </div>

    //                 {/* 
    //                                        <div className='p-4 rounded-full bg-[#FFFFFF]' style={{ boxShadow: "0px 3px 6px #00000029"}}>
    //                                        <Tb360View fontSize={25} color='black' />
    //                                    </div> 
    //                                    */}

    //                 <div
    //                   onClick={() => setSelectedView("video")}
    //                   className="p-4 rounded-full bg-[#FFFFFF]"
    //                   style={{
    //                     boxShadow: "0px 3px 6px #00000029",
    //                     backgroundColor:
    //                       selectedView === "video" ? "#75A7AD" : "#FFFFFF",
    //                   }}
    //                 >
    //                   <BsPlayCircleFill
    //                     fontSize={25}
    //                     color={selectedView === "video" ? "white" : "black"}
    //                   />
    //                 </div>
    //               </div>
    //               <div className="w-full">
    //                 {selectedView === "images" ? (
    //                   <DefaultCarousel
    //                     images={
    //                       color === "black"
    //                         ? selectedProduct.images_black
    //                         : selectedProduct.images_white
    //                     }
    //                   />
    //                 ) : (
    //                   <PlainVideo
    //                     height="220"
    //                     video={selectedProduct.video || ""}
    //                   />
    //                 )}
    //                 {/* <p className='text-[#005D6E] text-extrabold text-center'>1 out of 6</p> */}
    //               </div>
    //             </div>
    //           </div>
    //           <div className="basis-[50%] text-start md:px-20 px-10 flex flex-col gap-4 text-[#005D6E]">
    //             <div className="flex flex-col gap-4">
    //               <p className="font-semibold">Select your colour:</p>
    //               <div className="flex gap-4 justify-start">
    //                 <div
    //                   onClick={(e) => {
    //                     setColor("white");
    //                   }}
    //                 >
    //                   <RoundedCircleComponent bgColor="white" />
    //                 </div>
    //                 <div
    //                   onClick={(e) => {
    //                     setColor("black");
    //                   }}
    //                 >
    //                   <RoundedCircleComponent bgColor="black" />
    //                 </div>
    //               </div>
    //             </div>
    //             <h2 className="text-[30px] font-bold">
    //               {selectedProduct.name}
    //             </h2>
    //             <span>⭐️⭐️⭐️⭐️⭐️</span>
    //             <p className="text-[12px] font-light">
    //               {selectedProduct.description}
    //             </p>
    //             <p className="text-[12px] font-light">
    //               The Art features a retro design along with a unique
    //               carbonating lever.{" "}
    //             </p>
    //             <p className="text-[12px] font-light">
    //               Available in two classic colours, black and white, the machine
    //               seamlessly blends into any kitchen style. Make an Art-istic
    //               statement with endless possibilities.{" "}
    //             </p>
    //             <div className="flex gap-2 justify-start">
    //               <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
    //                 <img
    //                   src={Icons.IconBottle}
    //                   alt="bottle"
    //                   style={{ width: "35%" }}
    //                 />
    //                 <span className="text-[10px]">
    //                   Bottle Snap & Lock unique technology
    //                 </span>
    //               </div>
    //               <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
    //                 <img
    //                   src={Icons.IconCordless}
    //                   alt="bottle"
    //                   style={{ width: "35%" }}
    //                 />
    //                 <span className="text-[10px]">Cordless</span>
    //               </div>
    //               <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
    //                 <img
    //                   src={Icons.Icondishwasher}
    //                   alt="bottle"
    //                   style={{ width: "35%" }}
    //                 />
    //                 <span className="text-[10px]">Dishwasher safe bottle</span>
    //               </div>
    //               <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
    //                 <img
    //                   src={Icons.IconEgronomicButton}
    //                   alt="bottle"
    //                   style={{ width: "35%" }}
    //                 />
    //                 <span className="text-[10px]">
    //                   Ergonomic carbonation lever
    //                 </span>
    //               </div>
    //               <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
    //                 <img
    //                   src={Icons.IconPatentedButton}
    //                   alt="bottle"
    //                   style={{ width: "35%" }}
    //                 />
    //                 <span className="text-[10px]">
    //                   Patented Quick Connect system
    //                 </span>
    //               </div>
    //             </div>

    //             <div className="flex gap-2 justify-center border-y border-gray-300 py-5 mt-2 items-center">
    //               <img
    //                 src={Images.BottleClassic1L}
    //                 alt="bottle"
    //                 className="h-7 w-5"
    //               />
    //               <span className="font-semibold text-[#005D6E] text-[12px]">
    //                 1L Reusable Plastic Bottle
    //               </span>
    //             </div>

    //             <div className="mt-2 ">
    //               <Link to="/store-locator">
    //                 <SecondaryButton label="Store Locator" />
    //               </Link>
    //             </div>

    //             <div>
    //               <p className="font-semibold">Included in box</p>

    //               <div
    //                 className="rounded-2xl mt-5 overflow-hidden"
    //                 style={{ boxShadow: "0px 7px 20px #0000001A" }}
    //               >
    //                 {/* pack header */}
    //                 <div className="flex border">
    //                   {/* <div className='basis-[50%] px-10 py-5 border-b border-gray-200'>
    //                                        <h2 className='text-[24px] font-bold'>Hydration Pack</h2>
    //                                        <span>Rxxxx.xx Rxxxx.xx</span>
    //                                    </div> */}
    //                   <div className="basis-[100%] bg-[#EEEAE5] px-10 py-5">
    //                     <h2 className="text-[24px] font-bold">Starter Kit</h2>
    //                     {/* <span>Rxxxx.xx Rxxxx.xx</span> */}
    //                   </div>
    //                 </div>

    //                 {/* pack content */}
    //                 <div className="grid md:grid-cols-2 grid-cols-1 gap-4 text-[12px] px-10 py-4">
    //                   <div className="flex gap-2 items-center justify-start">
    //                     <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
    //                       1X
    //                     </span>
    //                     <span>Art Sparkling Water Maker</span>
    //                   </div>
    //                   <div className="flex gap-2 items-center justify-start">
    //                     <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
    //                       1X
    //                     </span>
    //                     <span>Quick Connect CO2 cylinder</span>
    //                   </div>
    //                   <div className="flex gap-2 items-center justify-start">
    //                     <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
    //                       1X
    //                     </span>
    //                     <span>1L Dishwasher Safe, PET bottle</span>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //             <div className="mt-5"></div>
    //             <div className="my-5">
    //               <div className="flex items-center justify-center flex-col gap-2">
    //                 <img src={Icons.IconCertification} alt="delivery" />
    //                 <span className="text-center w-32">2 year warranty </span>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //         <div className="md:px-20 px-10 py-10 flex gap-4 md:flex-row flex-col">
    //           {recommendations.map((recommendation, index) => (
    //             <RecommendationItem
    //               key={index}
    //               image={recommendation.image}
    //               title={recommendation.title}
    //             />
    //           ))}
    //         </div>

    //         <div className="md:px-20 px-10 pb-10 pt-5 flex gap-4 md:gap-20 items-center justify-center">
    //           <div className="flex flex-col gap-2 items-center">
    //             <img
    //               src={Icons.IconFreshWater}
    //               alt="bg"
    //               style={{ width: "70%" }}
    //             />
    //             <span className="text-[14px] text-[#005D6E] font-bold">
    //               Stay hydrated
    //             </span>
    //           </div>
    //           <div className="flex flex-col gap-2 items-center">
    //             <img
    //               src={Icons.IconHeathier}
    //               alt="bg"
    //               style={{ width: "70%" }}
    //             />
    //             <span className="text-[14px] text-[#005D6E] font-bold">
    //               Limitless taste
    //             </span>
    //           </div>
    //           <div className="flex flex-col gap-2 items-center">
    //             <img
    //               src={Icons.IconSustainability}
    //               alt="bg"
    //               style={{ width: "70%" }}
    //             />
    //             <span className="text-[14px] text-[#005D6E] font-bold">
    //               Save the planet
    //             </span>
    //           </div>
    //         </div>
    //       </section>

         
    //       <Footer />
    //     </div>
    //   ) : (
    //     <Loading />
    //   )}
    // </div>
  );
};

export default WaterMachinePreview;
